import { Button, Flex, Heading } from '@chakra-ui/react'
import type { ActionArgs, LoaderArgs } from '@remix-run/node'
import { redirect } from '@remix-run/node'
import type { ComponentProps } from 'react'

import type { SocialsProvider } from 'remix-auth-socials'
import { Form } from '~/components/Form'
import { authenticator, getUserIfLoggedIn } from '~/services/auth/auth.server'
import { MicrosoftLogo } from '../../lib/svg/MicrosoftLogo'
import { PHOCUSLogo } from '../../lib/svg/PHOCOSLogo'

type SocialButtonProps = {
    provider: keyof typeof SocialsProvider
    label: string
} & ComponentProps<typeof Button>

const SocialButton: React.FC<SocialButtonProps> = ({ provider, label, ...props }) => (
    <Form action={`/auth/microsoft`} method="post">
        <Button type="submit" {...props}>
            {label}
        </Button>
    </Form>
)

export const loader = async ({ request }: LoaderArgs) => {
    const user = await getUserIfLoggedIn(request)
    if (user) return redirect('/')
    return null
}

export const action = async ({ request }: ActionArgs) => {
    return await authenticator.authenticate('user-pass', request, {
        successRedirect: '/',
        failureRedirect: '/login',
    })
}

export default function Login() {
    return (
        <Flex flexDir="column" justifyContent="center" alignItems="center" w="full" h="full" mt={-50}>
            <Flex direction="row">
                <Flex direction="column" w={450}>
                    <Flex align="center" gap={4} mb={1}>
                        <PHOCUSLogo />
                        <Heading size="md">Primary Health Operational and Commissioning Unified System</Heading>
                    </Flex>
                    <Heading>Welcome to PHOCUS</Heading>

                    <SocialButton
                        leftIcon={<MicrosoftLogo />}
                        mt={4}
                        provider="MICROSOFT"
                        label="Login with Microsoft"
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}
